import { Card } from "@wingspanhq/wingspan-api-sdk";
import { WSList, WSPanel, WSText } from "@wingspanhq/fe-component-library";
import { FieldView } from "../../../../shared/components/FieldView/FieldView";
import React from "react";
import { WSQueries } from "../../../../query/WSQuery";
import { useQueryPrimaryComplianceEntity } from "../../../../shared/hooks/useQueryPrimaryComplianceEntity";
import { useCurrentAccountName } from "../../../../v3/providers/CurrentAccountNameProvider";
import { AddressText } from "../../../../shared/components/AddressText/AddressText";

export const CardBillingInfo: React.FC<{ card: Card }> = ({ card }) => {
  const accountName = useCurrentAccountName().resolvedName;
  // The address comes from the compliance entity rather than the account's
  // `expand=ComplianceEntity`: that projection serializes addresses as
  // `subdivision`/`countryCode`, which the SDK drops, losing state and
  // country (PLA-3658).
  const queryPrimaryComplianceEntity = useQueryPrimaryComplianceEntity();

  return (
    <WSPanel>
      <WSQueries queries={{ queryPrimaryComplianceEntity }}>
        {({ queryPrimaryComplianceEntityData: complianceEntity }) => {
          const address = complianceEntity?.physicalAddress;

          return (
            <WSList gap="L">
              <FieldView label="Name on card" value={accountName} />
              <FieldView
                label="Billing address"
                value={
                  <WSText.ParagraphSm as="pre">
                    <AddressText
                      placeholder="-"
                      addressLine1={address?.line1}
                      addressLine2={address?.line2}
                      city={address?.city}
                      state={address?.state}
                      postalCode={address?.postalCode}
                      country={address?.country}
                    />
                  </WSText.ParagraphSm>
                }
              />
            </WSList>
          );
        }}
      </WSQueries>
    </WSPanel>
  );
};
